import React from "react"
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


const TextTruncate = (props) => {
    const {text, length} = props

const renderTooltip = (props) => (   
    <Tooltip id="button-tooltip" {...props}>
        {text}
    </Tooltip>
    );
  return (
    <div>
        {
            text?.length > length ? (
                <OverlayTrigger
                    placement="top"
                    overlay={renderTooltip}>
                    <span>{text.slice(0, length) + '...'}</span>
                </OverlayTrigger>
            )  : <span>{text}</span>
        }
    </div>
  )
};

export default TextTruncate;